import classNames from 'classnames';
import styles from './Iframe.module.scss';

export type IframeProps = JSX.IntrinsicElements['iframe'];
export const Iframe = ({ className, src = '', ...props }: IframeProps) => (
  <iframe
    src={src}
    className={classNames(styles.root, className)}
    width="100%"
    height="100%"
    allow="clipboard-write"
    {...props}
  />
);
